<template>
    <div>
        <div id="body">
          <div id="header">
            <div id="headerText">{{ this.$i18n.t('CommentDialog.downloadAttachmentTitle', [commentTitle]) }}</div>
          </div>
          <div id="fileList" class="uk-overflow-auto" v-if="availableData">
            <vk-table narrowed :data="files" :selected-rows.sync="selection" id="table" :sortedBy.sync="sortOption">
              <vk-table-column-select></vk-table-column-select>
              <vk-table-column-sort title="FileName" cell="FileName"></vk-table-column-sort>
              <vk-table-column-sort title="Type" cell="FileExtension"></vk-table-column-sort>
              <vk-table-column-sort title="Size" cell="FileLengthFormated"></vk-table-column-sort>
            </vk-table>
          </div>
          <div v-else>
              <span id="headerText" :style="{'color': 'red'}">{{ this.$i18n.t('CommentDialog.errorMessage') }}</span>
          </div>
        <div id="buttons">
          <button @click="downloadFiles" :disabled="btnDownloadDisabled" id="download">{{ this.$i18n.t('CommentDialog.downloadButton', [selectedFilesCount]) }}</button>
          <button id="cancel" @click="close">{{ this.$i18n.t('CommentDialog.closeButtonText') }}</button>
        </div>
      </div>
  </div>
</template>

<script>
import * as commentApi from 'api/commentApi'
export default {
  name: 'CommentaAttachmentDownload',
  data () {
    return {
      commentId: this.$route.params.commentId,
      hashValue: this.$route.params.hash,
      userId: this.$route.params.userId,
      source: this.$route.query.source,
      commentTitle: '',
      files: [],
      selection: [],
      sortOption: {},
      availableData: true
    }
  },
  created () {
    // Call the api to get the data for the comment.
    commentApi.getAttachmentFilesList(this.commentId, this.userId, this.hashValue, this.source).then(response => {
      this.commentTitle = response.CommentName
      this.files = response.Files
      this.sortBy(this.files, 'FileName', this.sortOption['FileName'])
      this.availableData = true
    }).catch(() => {
      this.availableData = false
    })
  },
  computed: {
    btnDownloadDisabled () {
      return this.selection.length <= 0
    },
    selectedFilesCount () {
      return this.selection.length
    }
  },
  watch: {
    sortOption: function () {
      if (this.sortOption.hasOwnProperty('FileName')) {
        this.files.sort(this.sortBy('FileName', this.sortOption['FileName']))
      }
      if (this.sortOption.hasOwnProperty('FileExtension')) {
        this.files.sort(this.sortBy('FileExtension', this.sortOption['FileExtension']))
      }
      if (this.sortOption.hasOwnProperty('FileLengthFormated')) {
        this.files.sort(this.sortBy('FileLength', this.sortOption['FileLengthFormated']))
      }
    }
  },
  methods: {
    downloadFiles () {
      if (!this.btnDownloadDisabled) {
        // Put code to download files
        let self = this
        self.selection.forEach(item => {
          let selectedFile = self.files[item]
          commentApi.getFileDownloadLink(self.commentId, selectedFile.FileName, selectedFile.FileId).then(response => {
            commentApi.downloadFile(response)
          })
        }
        )
      }
    },
    close () {
      window.close()
    },
    sortBy (key, order = 'asc') {
      return function innerSort (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0
        }
        const varA = (typeof a[key] === 'string') ? a[key].toUpperCase() : a[key]
        const varB = (typeof b[key] === 'string') ? b[key].toUpperCase() : b[key]
        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return (
          (order === 'desc') ? (comparison * -1) : comparison
        )
      }
    }
  }
}
</script>

<style scoped>
div#buttons {
  bottom: 20px;
  height: 50px;
  position: absolute;
  right: 80px;
}
button {
  cursor: pointer;
  border-radius: 2px!important;
  background-color: #eeeeee;
  color: #58585b;
  transition: 0.2s;
  margin: 10px;
}
button:hover {
  background-color: #dddddd;
}
button:disabled {
  background-color: #f7f7f7 !important;
  color: #dddddd !important;
  border-color: grey!important;
  cursor:not-allowed;
}
button#cancel {
  float: right;
  height: 50px;
  width: 150px;
  background-color:  white;
  border:1px solid  lightgray;
}
button#download {
  float: right;
  height: 50px;
  width: 150px;
  background-color:  white;
  color:#782A8A;
  border:1px solid #782A8A;
}
button#download:hover {
  background-color: #5f256d;
  color: white;
}
button#download, button#cancel {
  font-size: 14px;
  font-weight: 500;
}
div#headerText {
  font-size: 25px;
  line-height: 80px;
  font-weight: bold;
  color:#782A8A;
}
#fileList {
  min-height: 500px;
  max-height: 700px;
  border-top: 1px solid darkgray;
  border-bottom: 1px solid darkgray;
  margin-top: 25px;
}
#body {
  padding-top: 30px;
  width: 90%;
  margin: auto;
}
</style>

<style>
  .uk-checkbox:checked, .uk-checkbox:checked:focus, .uk-checkbox:indeterminate:focus {
    background-color: #782A8A;
  }
  .uk-table-divider > tr:not(:first-child), .uk-table-divider > :not(:first-child) > tr, .uk-table-divider > :first-child > tr:not(:first-child) {
    border-top: none;
  }
  table.uk-table>thead{
    border-bottom: 1px solid darkgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/comment/CommentAttachmentDownload.vue